module.exports = __webpack_public_path__ + "img/bg5.f3e40858.jpg";